export const NO_CONTENT_MESSAGE =
  "No content available yet. Please transcribe or upload your assessment.";

export const FETCHING_MESSAGE = "Fetching assessment data.";
